import { Node, mergeAttributes } from '@tiptap/core';

export const Columns = Node.create({
    name: 'columns',
    group: 'block',
    content: 'column+',
    isolating: true,

    addAttributes() {
        return {
            count: {
                default: 2,
                parseHTML: (el) => parseInt(el.getAttribute('data-count'), 10) || 2,
                renderHTML: (attrs) => ({ 'data-count': attrs.count }),
            }
        };
    },

    parseHTML() {
        return [{ tag: 'div[data-type="columns"]' }];
    },

    renderHTML({ node, HTMLAttributes }) {
        return ['div', mergeAttributes(HTMLAttributes, {
            'data-type': 'columns',
            class: `tiptap-columns tiptap-columns--${node.attrs.count}`
        }), 0];
    },

    addCommands() {
        return {
            setColumns: (count = 2) => ({ commands }) => {
                const columnsToInsert = Array.from({ length: count }).map(() => ({
                    type: 'column',
                    content: [{ type: 'paragraph' }],
                }));

                return commands.insertContent({
                    type: this.name,
                    attrs: { count },
                    content: columnsToInsert,
                });
            },
        };
    },
});

export default Columns;
